import CloseIcon from '../../../assets/icons/General/close.svg?react';

export default function Chip({
  label,
  handleClick,
}: {
  label: string;
  handleClick?: () => void;
}) {
  return (
    <div className="border-taupe-600 text-grey-800 flex items-center justify-between gap-3 rounded-full border bg-white px-4 py-2 text-sm font-medium shadow-xs">
      <div className="text-sm font-normal">{label}</div>
      <button
        type="button"
        className="inline-flex items-center rounded-lg transition-all hover:opacity-75 focus:outline-none active:scale-90"
        onClick={handleClick}
      >
        <CloseIcon
          stroke="var(--color-grey-500)"
          className="w-[9px] min-w-[9px] cursor-pointer fill-current text-black"
        />
        <span className="sr-only">Remove '{label}'</span>
      </button>
    </div>
  );
}
